// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"86e24ff4","726":"c346ff58","787":"519ca993"}[chunkId] + ".chunk.js";
};